import React, { useState } from 'react';
import { Link, Modal } from 'react-style-guide';
import PropTypes from 'prop-types';
import GameName from '../components/GameName';
import CardInfo from '../components/CardInfo';
import NativeAd from '../components/NativeAd';
import GameThumbnailContainer from '../components/GameThumbnailContainer';
import gameTileUtils from '../utils/gameTileUtils';
import friendsService from '../../userData/services/friendsService';
import Players from '../../gamePlayers/components/Players';
import PlayerInteractionModal from '../../gamePlayers/containers/PlayerInteractionModal';

const GameTile = React.forwardRef((props, ref) => {
  const {
    game,
    pageType,
    index,
    sortName,
    pageContext,
    sortPosition,
    dateTime,
    friendsData,
    gameDetailPlaceId
  } = props;
  const { universeId } = game;
  const gameReferralUrl = gameTileUtils.getGameReferralUrl(
    game,
    pageType,
    index,
    sortName,
    pageContext,
    sortPosition,
    dateTime,
    gameDetailPlaceId
  );
  game.referralUrl = gameReferralUrl;

  const friendsInGame = friendsData.length
    ? friendsService.getFriendsInGame(friendsData, universeId)
    : [];

  const [isModalShown, setModalShown] = useState(false);
  const handlePlayerInteraction = () => {
    setModalShown(currentStatus => !currentStatus);
  };
  const dismissModal = () => {
    setModalShown(false);
  };

  return (
    <div className='game-card-container' ref={ref}>
      {friendsInGame.length > 0 && (
        <React.Fragment>
          <Link url={gameReferralUrl} className='game-card-link' id={game.universeId}>
            <GameThumbnailContainer universeId={game.universeId} />
          </Link>
          <GameName game={game} handlePlayerInteraction={handlePlayerInteraction} />
          <Players
            handlePlayerInteraction={handlePlayerInteraction}
            friendsData={friendsData}
            friendsInGame={friendsInGame}
          />
          <Modal show={isModalShown} onHide={dismissModal} size='lg'>
            <PlayerInteractionModal
              friendsData={friendsData}
              friendsInGame={friendsInGame}
              game={game}
              dismissModal={dismissModal}
              {...props}
            />
          </Modal>
        </React.Fragment>
      )}
      {friendsInGame.length === 0 && (
        <Link url={gameReferralUrl} className='game-card-link' id={game.universeId}>
          <GameThumbnailContainer universeId={game.universeId} />
          <GameName game={game} />
          {game.isSponsored && <NativeAd {...props} />}
          {!game.isSponsored && <CardInfo game={game} />}
        </Link>
      )}
    </div>
  );
});

GameTile.defaultProps = {
  sortName: null,
  sortPosition: -1,
  pageContext: { pageId: null },
  dateTime: null,
  friendsData: [],
  gameDetailPlaceId: null
};
GameTile.propTypes = {
  game: PropTypes.shape({
    universeId: PropTypes.number,
    placeId: PropTypes.number,
    name: PropTypes.string,
    playerCount: PropTypes.number,
    isSponsored: PropTypes.bool,
    nativeAdData: PropTypes.string,
    imageUrl: PropTypes.string,
    referralUrl: PropTypes.string
  }).isRequired,
  pageType: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  sortName: PropTypes.string,
  pageContext: PropTypes.shape({ pageId: PropTypes.string }),
  sortPosition: PropTypes.number,
  dateTime: PropTypes.string,
  friendsData: PropTypes.arrayOf(
    PropTypes.shape({
      presense: PropTypes.shape({ userPresenceType: PropTypes.number }),
      id: PropTypes.number,
      nameForDisplay: PropTypes.string
    })
  ),
  gameDetailPlaceId: PropTypes.number
};

export default GameTile;
